<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Ty Po Huat Goldsmith Inventory and Sales Login</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-alert dense dismissible lite text type="error" v-model="loginError">{{
                  loginErrorMessage
                }}</v-alert>
                <v-form>
                  <v-text-field
                    label="Login"
                    name="login"
                    prepend-icon="person"
                    type="text"
                    v-model="username"
                    v-on:keyup.enter="userAuthenticate"
                  />

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                    v-model="password"
                    v-on:keyup.enter="userAuthenticate"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" v-on:click="userAuthenticate" :loading="processingLogin"
                  >Login</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: function() {
    return {
      username: '',
      password: '',
      processingLogin: false,
      loginError: false,
      loginErrorMessage: '',
      layout: 'simple-layout'
    };
  },
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  mounted() {
    console.log('test');
    console.log(this.isAuthenticated);
    this.isAuthenticated && this.$router.push('/');
  },
  methods: {
    userAuthenticate: function() {
      this.processingLogin = true;
      axios
        .post('oauth/token', {
          username: this.username,
          password: this.password,
          grant_type: 'password',
          client_id: document.head.querySelector('[name=client_id]').content,
          client_secret: document.head.querySelector('[name=client_key]').content
        })
        .then(response => {
          this.loginError = false;
          const token = response.data.access_token;
          this.$store.commit('AUTH_SUCCESS', token);
          this.$router.push('/');
        })
        .catch(error => {
          this.loginError = true;
          const errorMessage = error.response.data.error;
          if (errorMessage == 'invalid_request') {
            this.loginErrorMessage = 'Username and Password required';
          } else if (errorMessage == 'invalid_grant') {
            this.loginErrorMessage = 'Invalid username and password.';
          }
        })
        .finally(() => {
          this.processingLogin = false;
        });
    }
  }
};
</script>
